import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import Partenaires from './pages/Partenaires';
import PartenaireDetail from './pages/PartenaireDetail';
import Statistiques from './pages/Statistiques';
import Abonnes from './pages/Abonnes';
import Factures from './pages/Factures';
import Forages from './pages/Forages';
import Paiements from './pages/Paiements';
import Productions from './pages/Productions';
import SecteursList from './pages/SecteursList';
import LocalitesList from './pages/LocalitesList';
import ChargesList from './pages/ChargesList';
import MobilePayments from './pages/MobilePayments';
import Users from './pages/Users';
import Cartographie from './pages/Cartographie';
import Comptabilite from './pages/Comptabilite';
import SmsBroadcast from './pages/SmsBroadcast';
import Analytics from './pages/Analytics';
import Tracking from './pages/Tracking';
import AgentPositions from './pages/AgentPositions';
import Mobile from './pages/Mobile';
import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          {/* /login redirige vers la landing, qui ouvrira automatiquement le popup */}
          <Route path="/login" element={<LandingPage />} />
          <Route path="/mobile" element={<Mobile />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="partenaires" element={<Partenaires />} />
              <Route path="partenaires/:id" element={<PartenaireDetail />} />
              <Route path="statistiques" element={<Statistiques />} />
              <Route path="abonnes" element={<Abonnes />} />
              <Route path="factures" element={<Factures />} />
              <Route path="forages" element={<Forages />} />
              <Route path="paiements" element={<Paiements />} />
              <Route path="productions" element={<Productions />} />
              <Route path="secteurs" element={<SecteursList />} />
              <Route path="localites" element={<LocalitesList />} />
              <Route path="charges" element={<ChargesList />} />
              <Route path="mobile-payments" element={<MobilePayments />} />
              <Route path="users" element={<Users />} />
              <Route path="cartographie" element={<Cartographie />} />
              <Route path="comptabilite" element={<Comptabilite />} />
              <Route path="sms-broadcast" element={<SmsBroadcast />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="tracking" element={<Tracking />} />
              <Route path="agent-positions" element={<AgentPositions />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
